import network from '@/services/network';
import { ApiResponse, TriageDiagnosis, TriageDiagnosisDetail } from '@/types';
import { ErrorResponse } from '@/utils';

// Auto-Fix-Diagnose-Seite (Anzeige-only) — Board aller Triage-Requests + Detail
// (Bug-Doc) + reine Anzeige-Markierung Gelesen/Ungelesen. Backend: role:sa.

const getDiagnoses = async (): Promise<ApiResponse<TriageDiagnosis[]>> => {
  try {
    const { data } = await network.get<ApiResponse<TriageDiagnosis[]>>(
      '/autofix/diagnoses',
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const getDiagnosis = async (
  id: number,
): Promise<ApiResponse<TriageDiagnosisDetail>> => {
  try {
    const { data } = await network.get<ApiResponse<TriageDiagnosisDetail>>(
      `/autofix/diagnoses/${id}`,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const markDiagnosisRead = async (
  id: number,
  read: boolean,
): Promise<ApiResponse<TriageDiagnosis>> => {
  try {
    const { data } = await network.patch<ApiResponse<TriageDiagnosis>>(
      `/autofix/diagnoses/${id}/read`,
      { read },
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const autofixApi = {
  getDiagnoses,
  getDiagnosis,
  markDiagnosisRead,
};

export default autofixApi;
